import { XAxisScrollbarOptions } from "highcharts";

export default function (config : XAxisScrollbarOptions = {}) {
    return {
        showFull: false,
        height: 8,
        enabled: true,
        barBorderColor: 'none',
        barBackgroundColor: '#CED8DE',
        barBorderRadius: 3,
        buttonBorderRadius: 0,
        buttonArrowColor: 'none',
        barBorderWidth: 0,
        buttonBackgroundColor: 'none',
        buttonBorderWidth: 0,
        trackBackgroundColor: 'none',
        trackBorderWidth: 0,
        trackBorderColor: 'none',
        ...(config || {})
    }
}